import React from "react";
import SvgComponent from "../SVGComponent";

/**
 * NavbarBoxComponent
 *
 * A reusable button component that displays a left icon, a title, and a right icon.
 * Can be disabled and handles a custom click event.
 *
 * @component
 *
 * @param {Object} props - Component props.
 * @param {string} props.iconLeft - URL or path to the left icon image.
 * @param {string} props.iconRight - URL or path to the right icon image.
 * @param {string} props.title - The text displayed in the button.
 * @param {boolean} [props.isDisabled=false] - Whether the button is disabled.
 * @param {boolean} [props.makeWhite=false] - If icon left is a black svg, should it be made white
 * @param {boolean} [props.maxWidth=false] - If want to set notification box component maxWidth
 * @param {(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [props.handleFunction] - Function called when the button is clicked.
 *
 * @returns {JSX.Element} The rendered NavbarBoxComponent.
 */
const NavbarBoxComponent = ({
  iconLeft,
  iconRight,
  title,
  isDisabled = false,
  handleFunction,
  makeWhite,
}) => {
  return (
    <button
      onClick={handleFunction}
      className={`flex items-center justify-between lg:w-navbar-box-component w-full p-padding-sm rounded-border-radius-md h-category-icon-height
        ${isDisabled ? "cursor-not-allowed opacity-50" : "global-hover-white z-0 relative cursor-pointer"}
      `}
    >
      <div className="flex gap-gap-sm items-center">
        {makeWhite ? (
          <SvgComponent
            color="var(--text-primary)"
            height={"var(--icon-md)"}
            width="var(--icon-md)"
            url={iconLeft}
            alt={`${title} left icon`}
          />
        ) : (
          <img
            src={iconLeft}
            alt={`${title} left icon`}
            className="w-icon-md h-icon-md"
          />
        )}
        <h4 className="text-text-primary font-normal text-font-sm">{title}</h4>
      </div>

      <SvgComponent
        color="var(--text-primary)"
        height={"var(--icon-sm)"}
        width="var(--icon-sm)"
        url={iconRight}
      />
    </button>
  );
};

export default NavbarBoxComponent;
